import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import InputFile from './InputFile'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Glyph from 'component/utils/Glyph'

const ACCEPTED_TYPES = ['.png', '.jpg', '.jpeg']

export const SCREEN_TYPES = {
  EDIT: 'EDIT',
}

export default class CustomInputFile extends PureComponent {
  static propTypes = {
    filePreview: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.object.isRequired,
    ]),
    handleFileChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    screen: PropTypes.string,
    showName: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    value: PropTypes.array,
    clearImage: PropTypes.func,
  }

  renderPreview = () => {
    const {
      filePreview: { name, fileToPreview },
      screen,
      showName,
      clearImage,
    } = this.props

    return (
      <>
        {!screen && <span className='image-preview-name'>{name}</span>}
        <div className='rectangle panel-border'>
          <Col lgOffset={10} xs={2}>
            {clearImage && (
              <span
                onClick={() => {
                  clearImage()
                  this.inputFileRef.value = null
                }}
                className='action'
              >
                <Glyph type='x margin-left' color='default' />
              </span>
            )}
          </Col>
          <Col xs={12}>
            <img
              src={fileToPreview}
              alt={name}
              onClick={() => this.inputFileRef.click()}
              className='image'
            />
          </Col>
        </div>
        {screen && screen === SCREEN_TYPES.EDIT && showName && (
          <span className='image-preview-name'>{name}</span>
        )}
      </>
    )
  }

  renderInput = () => {
    const { translate } = this.props

    return (
      <Row>
        <Col xs={12}>
          <button
            type='button'
            onClick={() => this.inputFileRef.click()}
            className='button button-primary button-full'
          >
            {translate('input-file.select-file')}
          </button>
        </Col>
      </Row>
    )
  }

  renderContent() {
    const { filePreview, screen, showName } = this.props

    if (screen && screen === SCREEN_TYPES.EDIT) {
      return (
        <>
          {this.renderPreview()}
          {!showName && this.renderInput()}
        </>
      )
    }
    return filePreview ? this.renderPreview() : this.renderInput()
  }

  render() {
    const { handleFileChange, translate } = this.props

    return (
      <>
        <InputFile
          accept={ACCEPTED_TYPES}
          className='hidden'
          inputRef={(inputFileRef) => {
            this.inputFileRef = inputFileRef
          }}
          onChange={handleFileChange}
          translate={translate}
        />

        {this.renderContent()}
      </>
    )
  }
}
